import React, { useEffect } from 'react';

import { commonAPI } from 'api/commonAPI';
import { cloneDeep } from 'lodash';
import {
  Route,
  Routes,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import {useRecoilState, useRecoilValue, useSetRecoilState} from 'recoil';
import {
    Alert,
    isAdmin,
    userInfo,
} from 'state';
import Coaching from 'view/pages/Coaching/Coaching';
import Create from 'view/pages/Create/Create';
import CreateCoaching from 'view/pages/CreateCoaching/CreateCoaching';
import Home from 'view/pages/Home/Home';
import InstructorApp from 'view/pages/InstructorApp/InstructorApp';
import Sign from 'view/pages/Sign/Sign';

import { GlobalStyle } from './styled/Reset.Styled';
import About from './view/pages/About/About';
import Classes from './view/pages/Classes/Classes';
import Contact from './view/pages/Contact/Contact';
import NotFound from './view/pages/NotFound';
import TestPage from "./view/pages/Test/TestPage";
import Profile from "./view/pages/Profile/Profile";
import TimeSettings from "./view/pages/Live/SubPage/TImeSettings";
import AlertMessage from "./view/components/common/AlertMessage";

const instructorStr = "instructor_application";
const redirectionPath = "/instructor_application"

const routes = [
    { path: "/main/:depth1", element: <Home /> },
    { path: "/about", element: <About /> },
    { path: "/contact", element: <Contact /> },
    { path: "/test", element: <TestPage /> },
    { path: "/*", element: <NotFound /> },
    { path: "/classes", element: <Classes /> },
    { path: "/create/:step", element: <Create /> },
    { path: "/create_coaching/:step", element: <CreateCoaching /> },
    { path: "/time_settings/:type", element: <TimeSettings /> },
    { path: "/login", element: <Sign /> },
    { path: "/instructor_application/:step", element: <InstructorApp /> },
];

const isAuthenticated = () => {
    const accessToken = sessionStorage.getItem("accessToken");
    return accessToken !== null;
};

const AppRoutes: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const setAdmin = useSetRecoilState(isAdmin);
    const setUser = useSetRecoilState(userInfo);
    const [alertState, setAlertState] = useRecoilState(Alert);


    useEffect(() => {
        const checkAuthentication = () => {
            if (!isAuthenticated()) {
                const currentPath = window.location.pathname;
                const index = currentPath.split("/").findIndex((item) => item === instructorStr);
                if (index === -1 || location.pathname === redirectionPath) {
                    navigate("/login", { replace: true });
                }
            }
        };
        checkAuthentication();
    }, [navigate]);

    useEffect(()=>{
        if(alertState.isActive){
            setTimeout(()=>{
                setAlertState({
                    ...alertState,
                    isActive: false
                })
            },alertState.time)
        }
    },[alertState.isActive])
    return (
        <React.Fragment>
            <GlobalStyle />
            {
                alertState.isActive &&
                <AlertMessage />
            }
            <Routes>
                {isAuthenticated() ? (
                    routes.map((route, index) => (
                        <Route key={index} path={route.path} element={route.element} />
                    ))
                ) : (
                    <React.Fragment>
                        <Route path="/instructor_application/:step" element={<InstructorApp />} />
                        <Route path="/login" element={<Sign />} />
                        <Route path={"/test"} element={<TestPage  />} />
                    </React.Fragment>
                )}
            </Routes>
        </React.Fragment>
    );
};

export default AppRoutes;
